import { Routes } from '@angular/router';



















export const routes: Routes = [
  { path: 'aidTypeForm', loadComponent: () => import('./components/aid-type-form/aid-type-form.component').then(m => m.AidTypeFormComponent) },
  { path: 'pccompatibility', loadComponent: () => import('./components/pc-compatibility/pc-compatibility.component').then(m => m.PcCompatibilityComponent) },
  { path: 'pcnotsupported', loadComponent: () => import('./components/pc-not-supported/pc-not-supported.component').then(m => m.PcNotSupportedComponent) },
  { path: 'compatibility', loadComponent: () => import('./components/compatibility-result/compatibility-result.component').then(m => m.CompatibilityResultComponent) },
  { path: 'compatability', redirectTo: 'compatibility', pathMatch: 'full' },
  { path: 'downloadpage', loadComponent: () => import('./components/download-page/download-page.component').then(m => m.DownloadPageComponent) },
  { path: 'MyStarkey', loadComponent: () => import('./my-starkey-reroute/my-starkey-reroute.component').then(m => m.MyStarkeyRerouteComponent) },
  {
    path: 'MyStarkey/DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent)
  },
  {
    path: 'MyStarkey/deleteAccount', redirectTo: 'MyStarkey/DeleteAccount', pathMatch: 'full'
  },
  {
    path: 'MyStarkey/AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent)
  },
  {
    path: 'MyAudibel', loadComponent: () => import('./my-audibel-reroute/my-audibel-reroute.component').then(m => m.MyAudibelRerouteComponent),
    children: [
      { path: 'DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent) },
      { path: 'deleteAccount', redirectTo: 'DeleteAccount', pathMatch: 'full' },
      { path: 'AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) }
    ]
  },
  {
    path: 'HearCircle', loadComponent: () => import('./components/hearcircle-reroute/hearcircle-reroute.component').then(m => m.HearcircleRerouteComponent),
    children: [
      { path: 'DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent) },
      { path: 'deleteAccount', redirectTo: 'DeleteAccount', pathMatch: 'full' },
      { path: 'AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) }
    ]
  },
  {
    path: 'MySoundGear', loadComponent: () => import('./components/my-soundgear-reroute/my-soundgear-reroute.component').then(m => m.MySoundGearRerouteComponent),
    children: [
      { path: 'DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent) },
      { path: 'deleteAccount', redirectTo: 'DeleteAccount', pathMatch: 'full' },
      { path: 'AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) }
    ]
  },
  {
    path: 'MyPhantom', loadComponent: () => import('./components/my-phantom-reroute/my-phantom-reroute.component').then(m => m.MyPhantomRerouteComponent),
    children: [
      { path: 'DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent) },
      { path: 'deleteAccount', redirectTo: 'DeleteAccount', pathMatch: 'full' },
      { path: 'AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) }
    ]
  },
  { path: 'Kindilink', loadComponent: () => import('./components/kind-reroute/kind-reroute.component').then(m => m.KindRerouteComponent) },
  {
    path: 'KindiLink3', loadComponent: () => import('./components/kind-reroute/kind-reroute.component').then(m => m.KindRerouteComponent),
    children: [
      { path: 'DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent) },
      { path: 'deleteAccount', redirectTo: 'DeleteAccount', pathMatch: 'full' },
      { path: 'AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) }
    ]
  },
  { path: 'audiologistInvite/:code', loadComponent: () => import('./my-starkey-reroute/my-starkey-reroute.component').then(m => m.MyStarkeyRerouteComponent) },
  { path: 'nuear', loadComponent: () => import('./components/aid-type-form/aid-type-form.component').then(m => m.AidTypeFormComponent) },
  { path: 'nuear/AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) },
  { path: 'audiosync', loadComponent: () => import('./components/aid-type-form/aid-type-form.component').then(m => m.AidTypeFormComponent) },
  { path: 'audiosync/AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) },
  {
    path: 'HearShare', loadComponent: () => import('./components/hear-share/hear-share.component').then(m => m.HearShareComponent),
    children: [
      { path: 'DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent) },
      { path: 'deleteAccount', redirectTo: 'DeleteAccount', pathMatch: 'full' }
    ]
  },
  {
    path: 'KindiLinkAssist', loadComponent: () => import('./components/kindilink-assist/kindilink-assist.component').then(m => m.KindiLinkAssistComponent),
    children: [
      { path: 'DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent) },
      { path: 'deleteAccount', redirectTo: 'DeleteAccount', pathMatch: 'full' }
    ]
  },
  {
    path: 'iProAI/DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent)
  },
  {
    path: 'iProAI/deleteAccount', redirectTo: 'iProAI/DeleteAccount', pathMatch: 'full'
  },
  {
    path: 'iProAI/landing', loadComponent: () => import('./components/delete-account/landing/delete-account-landing.component').then(m => m.DeleteAccountLandingComponent)
  },
  {
    path: 'iProAI/success', loadComponent: () => import('./components/delete-account-thrive-success/delete-account-thrive-success.component').then(m => m.DeleteAccountThriveSuccessComponent)
  },
  {
    path: 'iProAI/failure', loadComponent: () => import('./components/delete-account-thrive-failure/delete-account-thrive-failure.component').then(m => m.DeleteAccountThriveFailureComponent)
  },
  {
    path: 'Thrive/DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent)
  },
  {
    path: 'Thrive/deleteAccount', redirectTo: 'Thrive/DeleteAccount', pathMatch: 'full'
  },
  {
    path: 'Thrive/landing', loadComponent: () => import('./components/delete-account/landing/delete-account-landing.component').then(m => m.DeleteAccountLandingComponent)
  },
  {
    path: 'Thrive/success', loadComponent: () => import('./components/delete-account-thrive-success/delete-account-thrive-success.component').then(m => m.DeleteAccountThriveSuccessComponent)
  },
  {
    path: 'Thrive/failure', loadComponent: () => import('./components/delete-account-thrive-failure/delete-account-thrive-failure.component').then(m => m.DeleteAccountThriveFailureComponent)
  },
  { 
    path: 'Thrive/AccessData', loadComponent: () => import('./components/export-data/export-data.component').then(m => m.ExportDataComponent) 
  },
  {
    path: 'KindiLink2/DeleteAccount', loadComponent: () => import('./components/delete-account/delete-account.component').then(m => m.DeleteAccountComponent)
  },
  {
    path: 'KindiLink2/deleteAccount', redirectTo: 'KindiLink2/DeleteAccount', pathMatch: 'full'
  },
  {
    path: 'KindiLink2/landing', loadComponent: () => import('./components/delete-account/landing/delete-account-landing.component').then(m => m.DeleteAccountLandingComponent)
  },
  {
    path: 'KindiLink2/success', loadComponent: () => import('./components/delete-account-thrive-success/delete-account-thrive-success.component').then(m => m.DeleteAccountThriveSuccessComponent)
  },
  {
    path: 'KindiLink2/failure', loadComponent: () => import('./components/delete-account-thrive-failure/delete-account-thrive-failure.component').then(m => m.DeleteAccountThriveFailureComponent)
  },
  { path: 'delete-account-confirmation', loadComponent: () => import('./components/delete-account-confirmation/delete-account-confirmation.component').then(m => m.DeleteAccountConfirmationComponent) },
  { path: '**', loadComponent: () => import('./components/aid-type-form/aid-type-form.component').then(m => m.AidTypeFormComponent) },
];
